import React from 'react';
import {
  Container,
  Header,
  SpaceBetween,
  FormField,
} from '@cloudscape-design/components';
import { Control, FieldErrors, UseFormResetField } from 'react-hook-form';
import { FormInput } from 'src/components/v2/FormInput';
import { FormTextEditor } from 'src/components/v2/FormTextEditor';
import { TranslationFormData } from 'src/validations/translationFormSchema';
import { QUESTION_FIELD_NAMES, QUESTION_FIELD_LABELS } from 'src/contstant/commonLabels';

interface TranslationQuestionContentProps {
  control: Control<TranslationFormData>;
  errors: FieldErrors<TranslationFormData>;
  onTextEditorChange: (fieldName: string, value: string) => void;
  resetField: UseFormResetField<TranslationFormData>;
}

export const TranslationQuestionContent: React.FC<TranslationQuestionContentProps> = ({
  control,
  errors,
  onTextEditorChange,
  resetField,
}) => {
  return (
    <Container header={<Header variant="h2">Question Content</Header>}>
      <SpaceBetween size="l">
        <FormField
          label={QUESTION_FIELD_LABELS[QUESTION_FIELD_NAMES.TITLE]}
          stretch
          errorText={errors.title?.message}
        >
          <FormInput control={control} name={QUESTION_FIELD_NAMES.TITLE} />
        </FormField>

        <FormTextEditor
          control={control}
          name={QUESTION_FIELD_NAMES.QUESTION_TEXT}
          label={QUESTION_FIELD_LABELS[QUESTION_FIELD_NAMES.QUESTION_TEXT]}
          showFileUpload={false}
          onChange={(value) =>
            onTextEditorChange(QUESTION_FIELD_NAMES.QUESTION_TEXT, value)
          }
          showRestoreButton={true}
          onRestore={() => resetField(QUESTION_FIELD_NAMES.QUESTION_TEXT)}
        />

        <FormTextEditor
          control={control}
          name={QUESTION_FIELD_NAMES.AUDIT_INSTRUCTION}
          label={QUESTION_FIELD_LABELS[QUESTION_FIELD_NAMES.AUDIT_INSTRUCTION]}
          showFileUpload={false}
          onChange={(value) =>
            onTextEditorChange(QUESTION_FIELD_NAMES.AUDIT_INSTRUCTION, value)
          }
          showRestoreButton={true}
          onRestore={() => resetField(QUESTION_FIELD_NAMES.AUDIT_INSTRUCTION)}
        />

        <FormTextEditor
          control={control}
          name={QUESTION_FIELD_NAMES.PASS_CRITERIA}
          label={QUESTION_FIELD_LABELS[QUESTION_FIELD_NAMES.PASS_CRITERIA]}
          showFileUpload={false}
          onChange={(value) =>
            onTextEditorChange(QUESTION_FIELD_NAMES.PASS_CRITERIA, value)
          }
          showRestoreButton={true}
          onRestore={() => resetField(QUESTION_FIELD_NAMES.PASS_CRITERIA)}
        />

        <FormTextEditor
          control={control}
          name={QUESTION_FIELD_NAMES.FAIL_CRITERIA}
          label={QUESTION_FIELD_LABELS[QUESTION_FIELD_NAMES.FAIL_CRITERIA]}
          showFileUpload={false}
          onChange={(value) =>
            onTextEditorChange(QUESTION_FIELD_NAMES.FAIL_CRITERIA, value)
          }
          showRestoreButton={true}
          onRestore={() => resetField(QUESTION_FIELD_NAMES.FAIL_CRITERIA)}
        />

        <FormTextEditor
          control={control}
          name={QUESTION_FIELD_NAMES.JUSTIFICATION}
          label={QUESTION_FIELD_LABELS[QUESTION_FIELD_NAMES.JUSTIFICATION]}
          showFileUpload={false}
          onChange={(value) =>
            onTextEditorChange(QUESTION_FIELD_NAMES.JUSTIFICATION, value)
          }
          showRestoreButton={true}
          onRestore={() => resetField(QUESTION_FIELD_NAMES.JUSTIFICATION)}
        />
      </SpaceBetween>
    </Container>
  );
};
